import { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import "./DynamicForm.scss";
import {
	AbsDropDown,
	Button,
	Icon,
	ICONS,
	Input,
	TextArea,
} from "abs-ui-components";
import AsyncSelect from "react-select/async";

const DynamicForm = (props) => {
	const [inputData, setInputData] = useState([]);
	const [inputOptions, setInputOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showDelete, setShowDelete] = useState(false);
	const { payload, setPayload } = props;

	const convertedData = {};

	const constructDynamicPayload = (data) => {
		let result = {};
		data &&
			data.length > 0 &&
			Object.keys(data[0]).map((keyValue) => {
				result[keyValue] = [];
				data.forEach((item) => result[keyValue]?.push(item[keyValue]));
			});
		return result;
	};
	const constructInputFields = () => {
		if (inputData.length > 0) setShowDelete(true);
		props.fields.forEach((item) => {
			convertedData[item?.name] = "";
		});
		setInputData([...inputData, convertedData]);
		const dynamicPayload = constructDynamicPayload([
			...inputData,
			convertedData,
		]);
		setPayload((prevUnits) => {
			return { ...prevUnits, ...dynamicPayload };
		});
	};

	useEffect(() => {
		constructInputFields();
	}, []);
	// commenting as this creating issue when email is empty
	// useEffect(()=>{
	//     if(payload['Email']===undefined) {
	//         props.fields.forEach(item => {
	//             convertedData[item?.name] = '';
	//         });
	//         setInputData([{...convertedData}]);
	//     }
	// },[payload])

	const getOptions = (types, type) => {
		if (type === "dropdown")
			return types
				? types.map((e) => ({
						value: e,
						label: e,
				  }))
				: [];
		return types
			? types.map((e) => ({
					value: e,
					label: e,
					e: e,
			  }))
			: [];
	};

	const loadOptions = (inputValue, inputOptions, callback) => {
		setTimeout(() => {
			const optionsArray = Array.isArray(inputOptions)
				? inputOptions
				: [];
			const data = inputValue
				? optionsArray.filter((option) =>
						option.label
							.toLowerCase()
							.includes(inputValue.toLowerCase())
				  )
				: optionsArray;

			callback(data);
		}, 1000);
	};

	const handleChange = (index, keyValue) => {
		return true;
	};

	const deleteRow = (index) => {
		if (inputData.length > 1) {
			const filteredRows = inputData.filter((_, i) => i !== index);
			setInputData(filteredRows);
			if (filteredRows.length === 1) {
				if (Object.values(filteredRows[0]).some((val) => val != ""))
					setShowDelete(true);
				else setShowDelete(false);
			}
			const dynamicPayload = constructDynamicPayload(filteredRows);
			setPayload((prevUnits) => {
				return { ...prevUnits, ...dynamicPayload };
			});
		} else {
			let obj_keys = [];
			let updated_input_data = {};
			Object.keys(inputData[0]).map((item) => {
				obj_keys.push(item);
				updated_input_data[`${item}`] = "";
			});
			let filteredKeys = Object.fromEntries(
				Object.entries(payload).filter(
					([key]) => !obj_keys.includes(key)
				)
			);
			setPayload({ ...filteredKeys });
			setInputData([{ ...updated_input_data }]);
			setShowDelete(false);
		}
	};

	const onDataChange = (index, keyValue, value, dataType) => {
		if (inputData.length == 1) setShowDelete(true);
		let updated_input_data = [];
		if (dataType === "number" && isNaN(parseInt(value))) {
			value = inputData[index][keyValue];
		}
		setInputData((prevUnits) => {
			updated_input_data = [...prevUnits];
			updated_input_data[index][keyValue] = value;
			return updated_input_data;
		});
		const dynamicPayload = constructDynamicPayload(updated_input_data);

		setPayload((prevUnits) => {
			return { ...prevUnits, ...dynamicPayload };
		});
	};

	return (
		<div className="fuel-eu-dynamic-form mt-3">
			<table>
				<thead>
					<tr>
						{props.fields.map((field, index) => (
							<th key={index}>{field.label}</th>
						))}
						<th></th>
					</tr>
				</thead>
				<tbody>
					{inputData?.length > 0 &&
						inputData.map((item, index) => (
							<tr key={index}>
								{item &&
									Object.keys(item).map((keyValue, ind) => (
										<td key={`${index}-${ind}`}>
											<div id="dynamic-form-input-fields">
												{props.fields[ind].type ===
												"input" ? (
													<Input
														key={`${index}-${ind}-${keyValue}`}
														id="vessel_imo_number"
														type={
															props.fields[ind]
																.dataType
														}
														autoFocus={false}
														value={
															inputData[index][
																keyValue
															] || ""
														}
														onChange={(e) =>
															onDataChange(
																index,
																keyValue,
																e,
																props.fields[
																	ind
																].dataType
															)
														}
														className="input-height dynamic_form"
														required
													/>
												) : props.fields[ind].type ===
												  "textarea" ? (
													<TextArea
														rows={4}
														className="textarea-resize dynamic_form"
														value={
															inputData[index][
																keyValue
															] || ""
														}
														onChange={(e) =>
															onDataChange(
																index,
																keyValue,
																e
															)
														}
														autoFocus={false}
													/>
												) : props.fields[ind].type ===
												  "dropdown" ? (
													<AbsDropDown
														options={getOptions(
															props?.fields[ind]
																?.options,
															props?.fields[ind]
																?.type
														)}
														value={
															inputData[index][
																keyValue
															] || ""
														}
														selected={
															inputData[index][
																keyValue
															] || ""
														}
														handleChange={(e) =>
															onDataChange(
																index,
																keyValue,
																e.value
															)
														}
														placeholder={" "}
													/>
												) : props.fields[ind].type ===
												  "auto-dropdown" ? (
													<AsyncSelect
														cacheOptions
														key={index}
														defaultOptions={
															props.fields[ind]
																?.options
														}
														value={{
															value: inputData[
																index
															][keyValue],
															label: inputData[
																index
															][keyValue],
														}}
														loadOptions={(
															inputValue,
															callback
														) => {
															return loadOptions(
																inputValue,
																props.fields[
																	ind
																]?.options,
																callback
															);
														}}
														onChange={(
															selectedOption
														) =>
															onDataChange(
																index,
																keyValue,
																selectedOption
																	? selectedOption.value
																	: ""
															)
														}
														placeholder="Select..."
														isClearable={
															inputData[index][
																keyValue
															] === ""
																? false
																: true
														}
													/>
												) : (
													""
												)}
											</div>
											{props?.fields[ind]?.belowLabel && (
												<span
													style={{ color: "#6c757d" }}
												>
													{
														props?.fields[ind]
															?.belowLabel
													}
												</span>
											)}
										</td>
									))}
								<td>
									{((index === 0 && showDelete) ||
										index > 0) && (
										<IconButton
											color="error"
											onClick={() => deleteRow(index)}
										>
											<DeleteIcon />
										</IconButton>
									)}
								</td>
							</tr>
						))}
				</tbody>
				<tfoot>
					<tr>
						<td className="br-0">
							<Button
								onClick={() => {
									constructInputFields();
								}}
								startIcon={<Icon icon={ICONS.ADD} />}
								className="ml-2 add-button"
							>
								ADD ANOTHER
							</Button>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	);
};

export default DynamicForm;
